<template>
  <div class="share-box">
    <div class="picture-black" ref="imageBlackWrapper">
      <div class="black-header">
        <div class="logo">
          <img src="@/assets/images/share_logo.png"/>
        </div>
        <div class="black-img">
          <div class="user-header">
            <img :src='headImg' crossOrigin="Anonymous"/>
          </div>
        </div>
      </div>
      <div class="title-box">
        <div class="name">{{reportDetail.nickname}}</div>
        <div class="title">检测报告</div>
      </div>
      <div class="black-main">
        <div class="black-remark">
          <div class="remark-title">健康名言：</div>
          <div class="remark-content">健康是人生第一财富。<span>——爱默生</span></div>
          <div class="border-back"></div>
        </div>
        <div class="black-check">
          检测时间：{{reportDetail.checkTime}}
          <div class="tip-box">
            <img src="@/assets/images/tip_icon.png"/>
            请关注
          </div>
        </div>
         <div class="black-result">
            <div class="result-img">
              <img src="@/assets/images/blackre_bgm.png"/>
              <div class="result-title">
                <div class="subtitle">Detection Result</div>
                <div class="en-subtitle">检测结果</div>
              </div>
            </div>
            <div :class="['item-result' ,'result'+ind]" v-for="(item,ind) in shareBlackList" :key="ind">
              <div class="black-item">
                <img :src='require(`@/assets/images/${item.imgUrl}`)' class="icon"/>
                <img src="@/assets/images/tip_icon.png" v-if="item.levelsDesp!=1" class="tip-icon"/>
              </div>
            </div>
          </div>
      </div>
      <div class="tip-content">检测报告仅作为健康管理的参考数据，不代表临床诊断。</div>
      <div class="bottom-box">
        <div class="bottom-content">
          <div class="bottom-right">
            <img src="@/assets/images/black_share.png"/>
            <!-- <div class="bottom-item">居家智慧体检</div>
            <div class="bottom-item">疾病自动预警</div>
            <div class="bottom-item">数据实时可视</div>
            <div class="bottom-item">辅助精准治疗</div> -->
          </div>
          <div class="bottom-left">
            <div>
              <img src="@/assets/images/upload_img.png"/>
              德方云APP
            </div>
            <div>
              <img src="@/assets/images/wx_logo.png"/>
              德方云小程序
            </div>
          </div>
        </div>
        <div class="logo-title">德方智能体检机器人 坐享健康每一天</div>
      </div>
    </div>
    <div class="pre-box" style="background-image:url(https://dfosspic01.oss-cn-shenzhen.aliyuncs.com/dfcloud/pic/wechatpic/report_bgm.png)">
      <div class="mask">
        <div class="imgbox">
          <img :src='imgUrl'/>
          <div class="add-btn" @click='goBack()'>保存</div>
        </div>
      </div>
      <div class="list">
        <div class="user-mesg">
          <div class="user-box">
            <div class="sex">性别：{{reportDetail.sex}}</div>
            <div v-if="reportDetail.age!=0">年龄：{{reportDetail.age||''}}</div>
          </div>
          <div>检测设备：{{reportDetail.ctoolName||''}}</div>
          <div class="check-time">检测时间：{{reportDetail.checkTime||''}}</div>
        </div>
      </div>
      <div class="tab-box">
        <div class="tab-item"><span>健康提示</span></div>
        <div class="tab-item"><span>检测报告</span></div>
        <div class="tab-item" v-if="reportDetail.checkResultList.length!=0"><span>异常原因</span></div>
      </div>
      <div class="mains-box">
        <div id="text1">
          <div class="item">
            <div class="health-box">
              <div class="title">
                <div class="title-left">
                  健康提示
                </div>
              </div>
              <div class="content-box">
                <div class="content-item" v-for="(item,ind) in reportDetail.healthTipsList" :key='ind'>{{item}}</div>
              </div>
            </div>
          </div>
        </div>
        <div id='text2'>
        <div class="item">
          <div class="result-box">
            <div class="title">
              <div class="title-left">
                  检测报告
              </div>
              <div>
              </div>
            </div>
            <div class="result-content">
              <div class="result-item" v-for="(item,ind) in reportDetail.projectResltList" :key='ind'>
                <div class="item-name">{{item.projectName}}</div>
                <div :class="item.levelsDesp=='1'?'item-result':'item-result abnormal'">
                  <div class="relative">
                    {{levelCode[item.levelsDesp]}}
                  </div>
                </div>
              </div>
              <div class="report-tips"> 
                检测报告仅作为健康管理的参考数据，不代表临床诊断。
              </div>
            </div>
          </div>
        </div>
        </div>
        <div id='text3' v-if="reportDetail.checkResultList.length!=0">
        <div class="item">
          <div class="health-box">
            <div class="title">
              <div class="title-left">
                异常原因
              </div>
            </div>
            <div class="content-box">
              <div class="content-item" v-for="(item,ind) in reportDetail.checkResultList" :key='ind'>{{item}}</div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import html2canvas from "html2canvas"
import{ levelCode, shareBlackList } from '@/utils/diseaseConfig'
import { reqCheckRecordDetail, reqGetUserInfo } from '@/api/app'
import OSS, { base64ToFile } from '@/utils/oss';
export default {
  data(){
    return{
      imgUrl:'',
      dialogTableVisible:'',
      id:'',
      userId:'',
      reportDetail:{checkResultList:[],healthTipsList:[]},
      name:'',
      reportList:[],
      headImg:'',
      timer:null
    }
  },
  computed:{
    levelCode:()=>levelCode,
    shareBlackList:()=>shareBlackList
  },
  methods:{
   async toImg() {
      const imgUrl = await html2canvas(this.$refs.imageBlackWrapper,{backgroundColor:'#101113'}).then(canvas => {
      let dataURL = canvas.toDataURL("img/png");
      return dataURL
      });
      if (imgUrl !== "") {
        // 
        this.imgUrl= imgUrl
        const file = base64ToFile(imgUrl,'share')
        const result = await OSS(file);
        console.log(result)
        this.name = result.name
        // wx.miniProgram.redirectTo({ url: `/pages/UrineReport/index?id=${this.id}&userId=${this.userId}&url=${this.name}`});
      }
    },
    goBack(){
      wx.miniProgram.redirectTo({ url: `/pages/UrineReport/index?id=${this.id}&userId=${this.userId}&url=${this.name}`});
    },
    async getData(){
      const self = this;
      const postarr ={
        hcReportId:this.id,
        Authorization:this.$route.query.Authorization,
        tip:'图片生成中...'
      }
      await reqGetUserInfo({id:this.userId,Authorization:this.$route.query.Authorization,}).then(res=>{
        this.ImageToBase64(res.headImg)
      })
      reqCheckRecordDetail(postarr).then(res=>{
        console.log(res)
        if(res){
          this.reportDetail = res
          this.shareBlackList.forEach((v,ind)=>{
            const reportItem = res.projectResltList.find(m=>m.projectName==v.subText)
            this.shareBlackList[ind].levelsDesp = reportItem.levelsDesp
          })
          this.$nextTick(()=>{
            console.log(3333)
            self.timer = setInterval(() => {
              if(self.headImg){
                self.toImg()
                clearInterval(self.timer)
              }
            }, 5);
            
          })
        }
      })
    },
    async ImageToBase64( imageUrl ){
      //一定要设置为let，不然图片不显示
      let image = new Image();
      //解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = imageUrl
      //image.onload为异步加载
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var quality = 0.8;
        //这里的dataurl就是base64类型
        var dataURL = canvas.toDataURL("image/jpeg", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        console.log(2222)
         this.headImg = dataURL
      }
    }
  },
  mounted(){
    this.id = this.$route.query.id
    this.userId = this.$route.query.userId
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.share-box{
  position: relative;
}
.pre-box{
  width: 100%;
  min-height: 100vh;
  background-color:#fff ;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  height: 100%;
  overflow: hidden;
  .mask{
    position: absolute;
    width: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
    height: 100%;
    z-index: 999;
    // display: none;
    .imgbox{
      width: 80%;
      top: 50px;
      left: 10%;
      position: absolute;
      img{
        border-radius: 20px;
        min-height: 80vh;
      }
      .add-btn{
        background-color: #00CDE5;
        width: 240px;
        text-align: center;
        color: #fff;
        font-size: 32px;
        padding: 16px 0;
        border-radius: 64px;
        line-height: 1.3;
        margin: 0 auto;
        margin-top: 20px;
      }
    }
  }
}
.picture-black{
  background-color: #101113;
  .black-header{
    width: 100%;
    height: 394px;
    background-image: url(../assets/images/black_bgm.png);
    background-size: cover;
    position: relative;
    background-repeat: no-repeat;
    background-color: #101113;
    .logo{
      width: 248px;
      height: 68px;
      margin: 0 auto;
      padding-top: 60px;
    }
    .black-img{
      width: 184px;
      height: 184px;
      position: absolute;
      bottom: 42px;
      left: 50%;
      margin-left: -92px;
      background-image: url(../assets/images/logo_bgm.png);
      background-size: cover;
      overflow: hidden;
      .user-header{
        width: 164px;
        height: 164px;
        overflow: hidden;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        top: 50%;
        // transform: translate(-50%,-50%);
        margin-left: -82px;
        margin-top: -82px;
        background-color: #fff;
        img{
          display: block;
          width: 100%;
        }
      }
    }
  }
  .title-box{
    color: #ffffff;
    margin-top: -20px;
    background-color: #101113;
    .name{
      width: 336px;
      // height: 66px;
      font-size: 56px;
      font-weight: 700;
      line-height: 66px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: 24px;
      margin: 0 auto;
      text-align: center;
    }
    .title{
      font-size: 40px;
      line-height: 56px;
      margin-top: 6px;
      text-align: center;
    }
  }
  .black-main{
    padding: 0 32px;
    .black-check{
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #9FB9CB;
      font-size: 24px;
      margin-top: 24px;
      .tip-box{
        display: flex;
        align-items: center;
        img{
          width: 24px;
          display: block;
          height: 24px;
          margin-right: 8px;
        }
      }
    }
    .black-result{
      position: relative;
      width: 100%;
      height: 598px;
      .result-img{
        position: absolute;
        top: 0;
        left: 50px;
        width: 598px;
        height: 598px;
        img{
          display: block;
          width: 598px;
          height: 598px;
        }
        .result-title{
          width: 206px;
          position: absolute;
          top: 259px;
          text-align: center;
          color: #D0E3F0;
          left: 195px;
          .subtitle{
            font-size: 26px;
            margin-bottom: 16px;
            white-space: nowrap;
          }
          .en-subtitle{
            font-size: 32px;
            padding-bottom: 6px;
            background-image: url(../assets/images/line.png);
            background-size: 100% auto;
            background-repeat: no-repeat;
            background-position: bottom center;
          }
        }
      }
      .item-result{
        position: absolute;
        .black-item{
          // background-image:-webkit-linear-gradient(106deg,#00cde5 0%, #7174f5 100%); 
          // -webkit-background-clip:text; 
          // -webkit-text-fill-color:transparent; 
          font-size: 28px;
          .icon{
            display: block;
            width: auto;
            height: 0.5rem;
          }
          img.tip-icon{
            display: block;
            width: 24px;
            height: 24px;
            position: absolute;
            right: -30px;
            top: -6px;
          }
        }
      }
      .result0{
        top: 31px;
        left: 330px; 
      }
      .result1{
        top: 41px;
        left: 454px;
      }
      .result2{
        top: 106px;
        left: 537px;
      }
      .result3{
        top: 187px;
        left: 597px;
      }
      .result4{
        top: 301px;
        left: 597px;
      }
      .result5{
        top: 420px;
        left: 565px;
      }
      .result6{
        top: 507px;
        left: 475px;
      }
      .result7{
        top: 527px;
        left: 310px;
      }
      .result8{
        top: 507px;
        left: 141px;
      }
      .result9{
        top: 420px;
        left: 51px;
      }
      .result10{
        top: 317px;
        left: 20px;
      }
      .result11{
        top: 212px;
        left: 27px;
      }
      .result12{
        top: 119px;
        left: 51px;
      }
      .result13{
        top: 54px;
        left: 99px;
      }
    }
  }
  .black-remark{
    margin-top: -12px;
    .border-back{
      width: 100%;
      height: 1px;
      background-image: url(../assets/images/line.png);
      background-size: cover;
      margin-top: 24px;
    }
    .remark-title{
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      text-align: LEFT;
      color: #00cde5;
      line-height: 28px;
    }
    .remark-content{
      width: 686px;
      height: 50px;
      font-size: 36px;
      font-weight: 500;
      text-align: LEFT;
      color: #d0e3f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      span{
        font-size: 28px;
      }
    }
  }
  .tip-content{
    color: #9FB9CB;
    font-size: 24px;
    margin: 0 auto;
    margin-left: 32px;
    width: 688px;
    padding-bottom: 24px;
    background-image: url(../assets/images/line.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: bottom center;
  }
  .bottom-box{
    padding: 24px 32px;
    .bottom-content{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bottom-left{
        display: flex;
        justify-content: space-between;
        flex: 0 0 260px;
        text-align: center;
        font-size: 18px;
        color: #FFFFFF;
        align-items: center;
        white-space: nowrap;
        img{
          display: block;
          width: 114px;
          height: 114px;
          margin: 0 auto;
        }
      }
      .bottom-right{
        // display: flex;
        // flex-direction: row;
        // flex-wrap: wrap;
        // justify-content: space-between;
        flex: 0 0 400px;
        img{
          display: block;
          width: 100%;
        }
        .bottom-item{
          flex: 0 0 190px;
          // height: 44px;
          line-height: 46px;
          margin-bottom: 20px;
          // border: 1px solid #00CDE5;
          text-align: center;
          border-radius: 85px;
          color: #6FADE0;
          font-size: 26px;
          position: relative;
          height: 46px;
          // line-height: 46px;
          // padding: 12px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: url(../assets/images/item_back.png);
          background-size: cover;
          background-repeat: no-repeat;
          &:nth-child(2n-1):after{
            content: '';
            display: block;
            width: 8px;
            height: 8px;
            background-color: #00CDE5;
            border-radius: 8px;
            position: absolute;
            right: -14px;
            top: 18px;
          }
        }
      }
    }
    .logo-title{
      text-align: center;
      color: #D0E3F0;
      font-size: 32px;
      padding-top: 20px;
    }
  }
}
.list{
  margin: 0 auto;
  // margin-bottom: 60px;
  .user-mesg{
    font-size: 32px;
    color: #ffffff;
    padding: 32px 0;
    border-bottom: 2px solid rgba(255, 255, 255, 0.6);
    margin: 0 32px;
    .user-box{
      display: flex;
      margin-bottom: 24px;
      .sex{
        margin-right: 32px;
      }
    }
    .check-time{
      margin-top: 24px;
    }
  }
}
.tab-box{
  display: flex;
  padding: 0 32px;
  color: #ffffff;
  font-size: 32px;
  padding-top: 36px;
  .tab-item{
    flex: 0 0 33%;
    // margin-right: 150px;
    line-height: 52px;
    padding-bottom: 26px;
    text-align: center;
    &:first-child{
      text-align: left;
    }
    &:nth-child(3){
      text-align: right;
    }
  }
  .active span{
    font-weight: 700;
    position: relative;
    &::before{
      content: '';
      display: block;
      width: 46px;
      height: 4px;
      background-color: #ffffff;
      position: absolute;
      left: 50%;
      margin-left: -23px;
      bottom: -23px;
    }
  }
}
.mains-box{
  width: 686px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 90px;
 
  .item{
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 24px;
    padding: 32px;
    .title{
      font-size: 36px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      justify-content: space-between;
      img{
        width: 64px;
        height: 64px;
        display: block;
        margin-right: 16px;
      }
      .title-left{
        display: flex;
        align-items: center;
      }
      .more{
        display: block;
        width: 48px;
        height: 48px;
      }
    }
    .content-box{
      font-size: 28px;
      color: #808080;
      line-height: 1.5;
      .content-item{
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 1 solid #f2f2f2;
        &:last-child{
          padding-bottom: 0;
          border: 0;
          margin-bottom: 0;
        }
      }
    }
  }
}
.result-box{
  .disease{
    white-space: nowrap;
    display: flex;
    height: 27px;
    .sub-title{
      color: #808080;
      font-size:28px;
      display: inline-block;
      padding-right: 10px;
      margin-right: 28px;
      padding-bottom: 3px;
      line-height: 1.3;
      position: relative;
      padding-top: 6px;
      img{
        display: block;
        width: 12px;
        height: 12px;
        position: absolute;
        right: -3px;
        top: 0;
      }
      &:last-child{
        margin-right: 0;
      }
    }
    .active{
      color: #00CDE5;
      font-size: 32px;
      position: relative;
      &::after{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        margin-left: -18px;
        bottom: 0;
        height: 4px;
        width: 36px;
        background-color: #00CDE5;
        bottom: 0;
      }
    }
  }
  .result-content{
    margin-top: 8px;
    .result-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 24px;
      padding-bottom: 6px;
      border-bottom: 1px solid #f2f2f2;
      line-height: 1.3;
      &:nth-last-child(2){
        border: 0;
      }
      .item-name{
        font-size: 28px;
        color: #666666;
        font-weight: 700;
      }
    }
    .item-result{
      font-size: 28px;
      color: #666666;
      font-weight: 500;
    }
    .relative{
      position: relative;
      img{
        width: 32px;
        height: 32px;
        position: absolute;
        right: 0;
        top: -16px;
      }
    }
    .abnormal{
      color: #DC3536;
      .relative{
        position: relative;
        padding-right: 32px;
        img{
          display: block;
        }
      }
    }
    .report-tips{
      font-size: 12px;
      color: #B3B3B3;
      margin-top: 17px;
      display: flex;
      align-items: center;
      img{
        width: 28px;
        height: 28px;
        display: block;
        margin-right: 8px;
      }
    }
  }
}
</style>